<script lang="ts">
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import CurrentAuthService from 'shared/services/current-auth.service';
    import WalkerService from 'shared/services/walker.service';

    const localize = getLocalization();
    const currentAuthService = getInjector().getByClass(CurrentAuthService);
    const walker = getInjector().getByClass(WalkerService);
    const currentAuth$ = currentAuthService.currentAuth$();

    $: isAuthenticated = $currentAuth$.role.includes('ROLE_EXTERNALLY_AUTHENTICATED');

    function redirect() {
        walker.newPage('/login/oauth2/code/google', {redirect: window.location.href});
    }
</script>

<div class="login-system login-system-google">
    {#if isAuthenticated}
        <div>
            {localize(/* @kp-localization login.google.AlreadyLoggedAs */ 'login.google.AlreadyLoggedAs')}
            {$currentAuth$.activeUser.text}
        </div>
    {:else}
        <button class="btn btn-primary btn-block btn-google-login"
                data-qa="google-login-button"
                on:click={redirect}>
            {localize(/* @kp-localization login.google.LoginViaGoogle */ 'login.google.LoginViaGoogle')}
        </button>
    {/if}
</div>

<style lang="less">
    .btn-google-login {
        color: #fff;
        background-color: #ea4335;
        border-color: #ea4335;
    }

    .btn-google-login:hover,
    .btn-google-login:focus {
        color: #fff;
        background-color: #b42013;
        border-color: #b42013;
    }

    .btn-google-login:active {
        color: #fff;
        background-color: #b42013;
        border-color: #b42013;
    }
</style>